// rtk
export default {
    rtk1: '无定位',
    rtk2: 'GPS定位差',
    rtk3: 'RTK单点解定位',
    rtk4: 'RTK差分解定位',
    rtk5: 'RTK浮点解定位',
    rtk6: 'RTK固定解定位',
    rtk7: 'GPS定位',
}